import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueHTTP from 'vue-http2'
import http from './plugins/system/http.js' // 基于vue-http2封装业务http请求
import $window from './plugins/system/window.js'
// import log from './plugins/system/log.js'
import title from './plugins/system/title.js'
import event from './plugins/system/event.js'
import storage from './plugins/system/memory.js'
import Antd from 'ant-design-vue'
import VueDragAndDrop from './views/components/vue-drag-and-drop.js'
import 'ant-design-vue/dist/antd.less'
import Filters from 'vue2-filters'
import global_ from './global.js'
Vue.use(event)
Vue.use(Antd)
Vue.use(Filters)
Vue.use($window)
// Vue.use(log)
const message = new Vue()
Vue.use(VueHTTP, {
  duration: 500, // loading闪现时间
  root: process.env.API_ROOT,
  timeout: 20000, // 接口超时 3s超时
  autoFixedError: false,
  loading: (bool) => { // loading效果
    // Vue.loading(bool)
  },
  error: (text) => message.$error(text) // 错误处理
})
Vue.use(http)
Vue.use(title)
Vue.use(VueDragAndDrop)
Vue.use(storage)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Object.defineProperty(Vue.prototype, '$paths', {
  get () {
    return {
      editor: process.env.EDITOR,
      login: process.env.LOGIN_URL
    }
  }
})

Object.defineProperty(window, '_EVENTS', {
  get () {
    const supportTouch = 'ontouchstart' in window
    let supportPassive = false
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function () {
          supportPassive = true
        }
      })
      window.addEventListener('test', null, opts)
    } catch (e) {}
    return {
      touch: supportTouch,
      supportPassive,
      up: supportTouch ? 'touchend' : 'mouseup',
      down: supportTouch ? 'touchend' : 'mousedown',
      move: supportTouch ? 'touchmove' : 'mousemove'
    }
  }
})

Vue.filter('toTime', timeStamp => {
  if (!timeStamp) {
    return ''
  }
  let time = new Date(timeStamp * 1)
  let final = time.toLocaleDateString().replace(/\//g, '/') + ' ' + time.toTimeString().substr(0, 5)
  return final
})

function _report (errorObj) {
  Vue.prototype.$post('/api/front/errorParser', errorObj).then(ret => {
    let data = ret
    for (let k in data) {
      data[k] = `${data[k]}`
    }
    Vue.prototype.$report(data)
  })
}

// 资源加载上报
window.addEventListener('error', function _resourceError (e) {
  var target = e.target ? e.target : e.srcElement
  var options = {}
  options.message = e.target.localName + ' is load error'
  options.stack = 'resouce is not found'
  options.tagName = e.target.localName
  options.html = target.outerHTML
  options.errorType = e.type
  options.fileName = e.target.currentSrc
  options.category = 'resource'
  if (e.target !== window) {
    // 抛去js语法错误
    // 合并上报的数据，包括默认上报的数据和自定义上报的数据
    setTimeout(_ => Vue.prototype.$report(options), 0)
  }
}, true)
// js 上报
window.onerror = function _onerror (message, script, line, column, error) {
  if (message === 'Script error.' && !script) {
    return false
  }
  // 构建错误对象
  var o = {
    script,
    type: 'wuwei',
    from: 'global',
    name: error.name || '',
    message,
    line,
    col: column || (window.event && window.event.errorCharacter) || 0,
    stack: error && error.stack ? error.stack : null
  }

  if (!o.line) {
    let r = parseErrorStack(o.stack)
    if (r.length) {
      o.line = r[0].line
      o.script = r[0].file
      o.code = r[0].code
      o.col = r[0].col
    }
  }
  setTimeout(_ => _report(o), 0)
}

function parseErrorStack (message) {
  let files = message.split(/\bat/g)
  let r = []
  function _process (l) {
    const result = l.split(/[\s\t\r\n()]+/g)
    let [ code, file ] = result
    file = file.split(':')
    let col = file.pop()
    let line = file.pop()
    file = file.join(':')
    return { code, file, line, col }
  }
  for (let i = 1; i < files.length; i++) {
    r.push(_process(files[i].trim()))
  }
  return r
}

Vue.config.errorHandler = function _errorHandler (err, vm, info) {
  let o = { script: err.script, type: 'wuwei', from: 'vue', name: err.name, message: err.message, line: err.line, column: err.column, stack: err.stack }
  if (!o.line) {
    let r = parseErrorStack(o.stack)
    if (r.length) {
      o.line = r[0].line
      o.script = r[0].file
      o.code = r[0].code
      o.col = r[0].col
    }
  }
  setTimeout(_ => _report(o), 0)
}

Vue.prototype.GLOBAL = global_

const logger = new window.Tracker(global_.tracker.host, global_.tracker.project, global_.tracker.logstroe)
Vue.prototype.sendLogger = function (data) {
  const info = {
    data_id: new Date().getTime() + Math.random().toString().slice(-6),
    url: window.location.href,
    user_id: this.$storage.get('wuweiLogInfo') && this.$storage.get('wuweiLogInfo').user && this.$storage.get('wuweiLogInfo').user._id,
    project_id: this.$route.query.project_id || '',
    app_id: this.$route.query.app_id || '',
    page_id: this.$route.query.page_id || ''
  }
  const tar = JSON.stringify(Object.assign(info, data))
  logger.push('data', tar)
  logger.logger()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
